import * as React from "react";

export const IconDelete = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3414_11206)">
      <path
        d="M5.0013 15.8333C5.0013 16.75 5.7513 17.5 6.66797 17.5H13.3346C14.2513 17.5 15.0013 16.75 15.0013 15.8333L15.0013 5.83333L5.0013 5.83333L5.0013 15.8333ZM15.8346 3.33333L12.918 3.33333L12.0846 2.5L7.91797 2.5L7.08464 3.33333L4.16797 3.33333V5L15.8346 5V3.33333Z"
        fill="#E57373"
      />
    </g>
    <defs>
      <clipPath id="clip0_3414_11206">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
